import * as actionTypes from './actionTypes';

export function fetchFinancialInfo(payload) {
  return { type: actionTypes.FETCH_FINANCIALINFO, payload };
}
export function fetchFinancialInfoSuccess(payload) {
  return { type: actionTypes.FETCH_FINANCIALINFO_SUCCESS, payload };
}